import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InsertLinkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"insert_link"}/>
}
